var exports = {
  "i": "xaee3c4fa--cbdc86--wrapper",
};

module.exports = exports;
